import { Box, Text, Radio } from '@nimbus-ds/components';
import { InvoicesVariantRequestDto } from '@tiendanube/common';
import { Stack } from 'commons/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

interface TypesRadioProps {
  value?: string;
  onChange: (data: InvoicesVariantRequestDto) => void;
}

function TypesRadio({ value, onChange }: Readonly<TypesRadioProps>) {
  const t = useTranslationCatalog('products.detail.invoiceSettings');

  return (
    <Stack.Item fill>
      <Box gap="2">
        <Text fontSize="caption">{t('titleType')}</Text>
        <Box display="flex" flexDirection="row" gap="2">
          <Radio
            as="radio"
            name="product_type1"
            value="1"
            label={t('radioOwnProduction')}
            checked={value === '1'}
            onChange={() => onChange({ product_type: '1' })}
          />
          <Radio
            as="radio"
            name="product_type2"
            value="2"
            label={t('radioResale')}
            checked={value === '2'}
            onChange={() => onChange({ product_type: '2' })}
          />
        </Box>
      </Box>
    </Stack.Item>
  );
}

export default TypesRadio;
